module.exports = "/_next/static/images/img_3-mobile-d10d0af649ea2ffb85e7a615b0d5f22d.png";